import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation, Trans } from 'react-i18next';
import { Nav, NavItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FormAnalyticsComponents from '../individualConsultationFormsAnalytics';
import AnalysisDocuments from './AnalysisDocuments';

class IndividualConsultationFormResponses extends Component {
    constructor(props) {
        super(props);
        this.handleChildSelect = this.handleChildSelect.bind(this);

        const firstChild = this.props.children && this.props.children[0];
        this.state = {
            selectedChildId: firstChild && firstChild.id
        };
    }

    componentWillReceiveProps(nextProps) {
        if ((!this.props.children || this.props.children.length == 0) && nextProps.children && nextProps.children.length > 0) {
            this.handleChildSelect(nextProps.children[0].id);
        }
    }

    handleChildSelect(childId) {
        this.setState({ selectedChildId: childId });
    }

    render() {
        const { children, hasChildren, formsDashboard, t } = this.props;

        if (!children || children.length == 0) {
            return <Trans i18nKey='FO_IndividualConsultationForm_NoConsultations'>
                <Link to={`/individual-consultation/booking/child?add=${!hasChildren}&reset=true`}>Book</Link> individual consultation
            </Trans>;
        }

        const { selectedChildId } = this.state;

        return <div>
            {children.length > 1 ? <Nav id='children' bsStyle='pills' activeKey={selectedChildId} onSelect={this.handleChildSelect}>
                {children.map(x => <NavItem key={x.id} eventKey={x.id} title={x.fullName}>
                    {x.fullName}
                </NavItem>)}
            </Nav> : <h3>{children[0].fullName}</h3>}
            <div style={{ marginTop: '10px' }}>{formsDashboard && selectedChildId && FormAnalyticsComponents(formsDashboard, { childId: selectedChildId })}</div>
            <AnalysisDocuments childId={selectedChildId}></AnalysisDocuments>
        </div>;
    }
}

const mapStateToProps = state => {
    const {
        configuration: { franchisor },
        parent: { children }
    } = state;


    return {
        children: children.filter(x => x.hasIndividualConsultation),
        hasChildren: children.length > 0,
        formsDashboard: franchisor.customUIComponents && franchisor.customUIComponents.childFormsDashboard
    };
};

export default connect(mapStateToProps, {})(withTranslation()(IndividualConsultationFormResponses));